import {
  getFirestore,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  collection,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";

export const Createitem = async (data) => {
  if (!data?.puid) {
    return { success: false, error: "Missing PUID for user document." };
  }
  if (!data?.itemname) {
    return { success: false, error: "Missing name." };
  }
  if (!data?.taskuid) {
    return { success: false, error: "Missing task TaskUID." };
  }
  if (!data?.itemuid) {
    return { success: false, error: "Missing ItemUID." };
  }
    if (!data?.groupuid) {
    return { success: false, error: "Missing  groupuid." };
  }
  const adminguid = Cookies.get("adminguid") || "";
  const guid = Cookies.get("guid") || "";
  const ip = Cookies.get("ipaddress") || "";
  const device = typeof navigator !== "undefined" ? navigator.userAgent : "";
  try {
    const checkQuery = query(
      collection(db, "projectstaskitem"),
      where("adminguid", "==", adminguid),
      where("puid", "==", data.puid),
      where("taskuid", "==", data.taskuid),
      where("taskname", "==", data.itemname),
       where("groupuid", "==", data.groupuid),      
    );
    const checkSnap = await getDocs(checkQuery);
    if (!checkSnap.empty) {
      return { success: false, error: "Task with the same name already exists." };
    }
    let indexstage = 1;
    const indexstageQuery = query(
      collection(db, "projectstaskitem"),
      where("puid", "==", data.puid),
      where("taskuid", "==", data.taskuid),
        where("groupuid", "==", data.groupuid),
      where("adminguid", "==", adminguid),
    );
    const indexstageSnap = await getDocs(indexstageQuery);
    if (!indexstageSnap.empty) {
      indexstage = indexstageSnap.size + 1;
    }
    const docRef = doc(db, "projectstaskitem",data.itemuid);
    const timestamp = Timestamp.now();
    const savequery = {
      ...data,
      guid, 
      itemstatus:"Not accepted",
      itemstatuscolor:"#555",
      adminguid,
      ip,
      device,
      status_complete: 0, 
      date_time: timestamp,
      update_date_time: timestamp,
      save: false,
      locked: false,
      status: true,
      archived: false,
      indexstage,
    };

    await setDoc(docRef, savequery);
    return { success: true };

  } catch (err) {
    console.error("Error creating task:", err);
    return { success: false, error: err.message || "Unknown error occurred" };
  }
};
